import { getPoListThunkAndSlice } from "./poListSlice";

export interface IPoHeadliner {
	Event_Headliner_ID: number;
	Event_Headliner: string;
	Cat_ID: number;
}

export const { thunk: listPoHeadliners, slice: listPoHeadlinersSlice } = getPoListThunkAndSlice<IPoHeadliner>({
	name: "poHeadliners",
	path: "/api/Purchasing/ListHeadliners",
	fallbackPath: "/api/Pricing/ListHeadliners",
});
